import { render } from "./FirstFishCelebration.vue?vue&type=template&id=a834fe98&scoped=true"
import script from "./FirstFishCelebration.vue?vue&type=script&lang=js"
export * from "./FirstFishCelebration.vue?vue&type=script&lang=js"

import "./FirstFishCelebration.vue?vue&type=style&index=0&id=a834fe98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a834fe98"]])

export default __exports__